import { axiosInstance, instanceAuth } from "api/apiConfig"

export const committeeChatMessagesFetchAPI = async data => {
  try {
    console.log("chatroom message for:", data)
    const response = await instanceAuth.get("StaffChat/GetStaffChats", {
      params: {
        ...data,
      },
    })
    return response
  } catch (error) {
    console.log("error fetching chat users...", error)
    throw error
  }
}

export const committeeSendMessageAPI = async data => {
  console.log("Sending message:", data)
  try {
    const response = await instanceAuth.post("StaffChat/SendMessage", data)
    return response
  } catch (error) {
    console.log("error sending message...", error)
    throw error
  }
}
